import { faQuestionCircle } from '@fortawesome/pro-regular-svg-icons'
import { Tooltip, TooltipProvider, Icon } from '../../atoms'
import { TextColors } from '../../../utils/style-helpers'

const DefaultTrigger = () => (
  <Icon
    icon={faQuestionCircle}
    className="ml-2"
    color={TextColors.MUTED}
    size="sm"
  />
)

export interface ToolTipProps {
  tooltipContentClassName?: string
  tooltipTriggerClassName?: string
  content: React.ReactNode
  trigger?: React.ReactNode
  side?: 'top' | 'right' | 'bottom' | 'left'
  maxWidth?: string
}

export const Popup = ({
  side = 'top',
  trigger = <DefaultTrigger />,
  content,
  tooltipContentClassName,
  tooltipTriggerClassName,
  maxWidth = 'max-w-xs', // Default maxWidth using Tailwind
}: ToolTipProps) => (
  <TooltipProvider>
    <Tooltip>
      <Tooltip.Trigger asChild>
        <span className={`inline-flex ${tooltipTriggerClassName}`}>
          {trigger}
        </span>
      </Tooltip.Trigger>

      <Tooltip.Content
        side={side}
        className={`bg-neutral-25 p-4 rounded-md shadow-sm ${tooltipContentClassName} ${maxWidth} max-w-full sm:max-w-xs`}
      >
        {content}
      </Tooltip.Content>
    </Tooltip>
  </TooltipProvider>
)
